import DataTableField from '@/components/DataTable/DataTableField'
import Tenant from '@/models/Tenant'
import router from '@/Routes'

export default [
  new DataTableField('checkbox', '', 'checkbox', true, false),
  {
    key: 'id',
    label: 'ID',
    sortable: true,
    class: 'text-center align-middle',
    show: false,
    thClass: 'align-middle text-center',
    thStyle: { width: '10%' },
  },
  {
    key: 'database_settings',
    type: 'object',
    object: {
      key: 'database_settings',
      property: 'tenancy_db_name',
    },
    label: 'Database',
    sortable: true,
    class: 'text-center align-middle',
    show: true,
    thClass: 'align-middle text-center',
  },
  {
    key: 'app_url',
    label: 'Frontend Domain',
    sortable: true,
    class: 'text-center align-middle',
    show: true,
    thClass: 'align-middle text-center',
  },
  {
    key: 'domain',
    label: 'Domain',
    sortable: true,
    class: 'text-center align-middle',
    show: true,
    thClass: 'align-middle text-center',
  },
  {
    // status
    key: 'status',
    label: 'Status',
    sortable: true,
    class: 'text-center align-middle',
    show: true,
    thClass: 'align-middle text-center',
  },
  {
    key: 'action',
    label: '',
    sortable: false,
    class: 'text-center align-middle text-capitalize',
    show: true,
    type: 'action_list',
    actions: [
      {
        icon: 'pencil',
        title: 'Edit',
        event: 'edit',
        top_level: true,
        action: (tenant: Tenant) => {
          router.push({
            name: 'tenant',
            params: { id: tenant.id! },
          })
        },
      },
      // {
      //   icon: 'sync',
      //   title: 'Force Reload',
      //   event: 'reload',
      //   action: (billboard: Billboard) => {
      //     WebMessage.confirm(
      //       'Are you sure you want reload the billboard? Please make sure you have access to the billboard in case you need to reenter the PIN!',
      //       'Reload Billboard',
      //       {
      //         okTitle: 'Yes',
      //         cancelTitle: 'No',
      //       },
      //     ).then((result: boolean) => {
      //       if (result) billboard.reload()
      //     })
      //   },
      // },
      {
        icon: 'trash',
        title: 'Delete',
        event: 'delete',
        // should use the event and popup a modal to confirm what to delete from tenant
      },
    ],
  },
]
